import React, { useState } from 'react';
import interfaces from '../../../interface';
import { message } from 'antd';
import UnboundDomain from './UnboundDomain';
import BoundDomain from './BoundDomain';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useAsync } from '../../../hooks'
import { SettingAPI } from '../../../requests'
import { baseInfo } from './interface'
import './style.less'

const clsPrefix = "cn-domain-setting"

const DomainSettingContainer: React.FC<interfaces.DomainSettingContainerProps> = ({
  siteId = undefined
}) => {
  const [isShowCopy, setIsShowCopy] = useState(false);
  

  const { result = [], loading } = useAsync<unknown>(
    () => SettingAPI.getGrade({
      siteids: siteId,
    })
  )
  const { result: baseDomainInfo, loading: baseLoading, execute } = useAsync<unknown>(
    () => SettingAPI.getDomainInfo(siteId)
  )


  //@ts-ignoree
  const packageType: string = result[0]? result[0].packageType : "";

  //@ts-ignore
  const baseInfo: baseInfo = baseDomainInfo

  function getCode(siteUrl?:string) {
    return  `
    <link rel="alternate" type="application/vnd.wap.xhtml+xml" media="handheld" href="${siteUrl}"/>
    <script src="//cdn.kuaizhan.com/res/skin/js/uaredirect.js?v=5.0" type="text/javascript"></script>
    <script type="text/javascript">KZ.redirect("${siteUrl}");</script>
  `
  }

  return (
    <div className={clsPrefix}>
      {baseInfo && baseInfo.showWarm === 'show' &&  
        <div className={`${clsPrefix}__warm-message`}>
          <p>
            <span>通知</span>
            {` `}由于腾讯云遭遇不明攻击，导致近期独立域名出现间歇性无法访问的情况，站长解绑当前独立域名，重新配置CNAME并绑定，可解决此类问题
          </p>
        </div>
      }
      <div className={`${clsPrefix}__wrap`}>
        <div className={`${clsPrefix}__title`}>
          <p><span>绑定独立域名</span></p>
          <div className={`${clsPrefix}__premium-tip`}>
              <i></i>
              {packageType === "SITE_FREE" && (
                <>
                  <span>绑定独立域名功能，仅限尊享版用户使用。</span>
                  <a href="/homepage/pricing">立即开通尊享版 &gt;&gt;</a>
                </>
              )}
              {packageType === "SITE_EXCLUSIVE" && <span>尊享版用户专享功能</span>}
          </div>
        </div>
        {baseInfo && baseInfo.privateDomain ? (
          <BoundDomain baseInfo={baseInfo} siteId={siteId} execute={execute}/>
        ):(
          <UnboundDomain packageType={packageType} siteId={siteId} execute={execute}/>
        )}
      </div>
      <div className={`${clsPrefix}__copy-code`}>
        <div style={{padding:'0 20px'}}>
          <a href="javascript:;" onClick={() => setIsShowCopy(!isShowCopy)}>如何不经过以下配置，让手机打开PC站时自动跳转到快站</a>
          <div className={`${clsPrefix}__code-wrap`} style={{display:`${isShowCopy? 'block':'none'}`}}>
            <p>{`请将如下代码添加在PC站点首页<head>标签中`}</p>
            <textarea disabled value={getCode(baseInfo && baseInfo.siteUrl)}></textarea>
            <CopyToClipboard text={getCode(baseInfo && baseInfo.siteUrl)}
              onCopy={()=>message.success('复制成功')}>
                <span>复制代码</span>
            </CopyToClipboard>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DomainSettingContainer;